const selector = {
    checkoutForm: '#form_checkout',
    checkTerms: '#check_terms',
    serialNumber: '#tag_serial_number',
    serialNumberConfirmation: '#tag_serial_number_confirmation',
    registrationPlate: '#registration_plate',
    helperMsg: '#helper_msg',
    tagCollapse: '.tag-collapse',
    btn: {
        submit: '#btn_submit'
    },
    form: {
        customerType: 'input[name="customer_type"]',
        customerTypeChecked: 'input[name="customer_type"]:checked',
        customer: {
            cardholderName: '#cardholder_name',
            cardholderSurname: '#cardholder_surname',
        },
        business: {
            companyName: '#company_name',
            mb: '#mb', 
            pib: '#pib',
        },
        tagType: 'input[name="tag_type"]',
    },
};

export { selector };